import { toast } from "sonner";

/**
 * Open an external link in a new tab.  In sandboxed iframes (e.g. the
 * preview environment), popups to certain hosts are blocked.  If the
 * popup is blocked or the host refuses the connection, we copy the
 * handle to the clipboard and surface a friendly toast so the user can
 * still reach the destination.
 */
export function openExternal(url, fallbackText) {
    try {
        const win = window.open(url, "_blank", "noopener,noreferrer");
        if (!win || win.closed || typeof win.closed === "undefined") {
            throw new Error("popup-blocked");
        }
    } catch (_err) {
        if (fallbackText && navigator.clipboard) {
            navigator.clipboard.writeText(fallbackText).catch(() => {});
        }
        toast.message("No pudimos abrir el enlace en este navegador", {
            description: fallbackText
                ? `Copiamos el dato al portapapeles: ${fallbackText}`
                : `Pega esta URL en una pestaña nueva: ${url}`,
            duration: 6000,
        });
    }
}
